module.exports = __webpack_public_path__ + "img/erma.43d92dac.jpg";